<template>
	<div v-if="shouldDisplayLadderInTeam && roundsToShow.length > 0 && (!WP.team || (leagueId !== 4 && leagueId !== 9)) || ((leagueId === 4 || leagueId === 9) && showLadderInNationalTeamPages)">
		<p v-if="isOverviewPage" class="text-xl font-semibold pl-2.5 mb-2.5 mt-6 xl:pl-0">Drabinka - {{ leagueName }}</p>
		<div>
			<Transition name="fade">
				<div v-if="!loading && Object.keys(rounds).length > 0"
             class="border w-full border-zt-light rounded-zt bg-zt-light/35"
             :class="{ 'h-[568px]': isEuroOnMainPage && window.size.desktop, '!bg-zt-light-opacity': isEuroOnMainPage }">
					<div class="flex px-2 py-2.5 justify-between">
						<div @click="previousRound()"
						     :class="roundIndex === 0 ? 'opacity-50' : 'zt-hover cursor-pointer'"
						     class="py-[6px] px-[16px] font-normal text-xs uppercase border border-zt-light rounded-zt">
							Poprzednia runda
						</div>
						<div @click="nextRound()"
						     :class="roundIndex + noOfDisplayedRounds < noOfRounds ? 'zt-hover cursor-pointer' : 'opacity-50'"
						     class="py-[6px] px-[16px] font-normal text-xs uppercase border border-zt-light rounded-zt">
							Następna runda
						</div>
					</div>
					<div class="overflow-x-hidden">
						<div class="flex px-[7px] py-2.5 bg-zt-light-full text-center text-xs font-normal gap-x-5 border-y
						            border-zt-light w-full">
							<div v-for="round in roundsToShow" class="w-full xl:w-[294px]">
								{{ cupRoundName(round[0], 0, round[1].round_matches.length) }}
							</div>
						</div>
					</div>
					<div ref="bracket" class="max-h-[540px] overflow-y-auto"
               :class="{ '!max-h-[478px]': isEuroOnMainPage, 'h-[478px]': isEuroOnMainPage && window.size.desktop }">
						<Transition mode="out-in">
							<div :key="roundIndex" class="pl-[6px] flex gap-x-5 overflow-x-hidden"
                   :class="{ 'min-h-[478px] max-h-[664px] items-center': isEuroOnMainPage && window.size.desktop }">
								<div class="flex flex-col w-[calc(100%-9px)] xl:w-fit"
                     :style="{ height: `${baseDivHeight * roundsToShow[0][1]['round_matches'].length}px` }"
								     :class="{ '!h-[130px]': (noOfDisplayedRounds === 1 || (window.size.desktop && noOfDisplayedRounds === 2)) && cupRoundName(roundsToShow[0][0]) === 'Finał',
								               '!h-[204px] xl:!h-[222px]': roundsToShow[0][1].third_place}">
									<div class="grid items-center relative h-[83px]"
									     :class="{ 'bracket-lines before:h-full': index % 2 === 0 && !(noOfRounds === 1 && [81,143,108, 2,3,848, 913].includes(leagueId)),
									     'before:!left-2.5 before:!w-full': roundIndex === 0 && index % 2 === 0,
									     '!h-[130px]': noOfDisplayedRounds === 1 && cupRoundName(roundsToShow[0][0]) === 'Finał',
									     'before:!border-b-0 before:!border-r-0 before:!w-[294px] before:!h-fit before:left-2.5': cupRoundName(roundsToShow[0][0]) === 'Finał' }"
									     :key="match.match_id"
									     v-for="(match, index) in roundsToShow[0][1]['round_matches']">
										<LadderMatch
                        :class="{ 'top-5' : cupRoundName(roundsToShow[0][0]) === 'Finał' && window.size.desktop }"
                        :league_id="leagueId" :variant="cupRoundName(roundsToShow[0][0]) === 'Finał' ? 'final' : ''"
                                 :match="match" :column-count="isEuroOnMainPage && window.size.desktop ? 3 : 2"/>
										<LadderMatch class="!absolute top-[132px] !w-full xl:top-[150px]" variant="third"
                                 v-if="roundsToShow[0][1].third_place" :match="roundsToShow[0][1].third_place" />
									</div>
								</div>
								<div v-if="roundsToShow[1] && noOfDisplayedRounds > 1" class="flex flex-col"
								     :class="{ '!h-[222px]' : roundsToShow[1][1].third_place }"
								     :style="{ height: `${baseDivHeight * roundsToShow[0][1]['round_matches'].length}px` }">
									<div class="grid items-center relative h-[166px]"
									     :class="{ 'bracket-lines before:h-full': index % 2 === 0 && !(roundIndex + noOfDisplayedRounds === noOfRounds && [81,143,108].includes(leagueId)),
									     'after:w-2.5 after:h-1 after:border-b after:border-zt-light after:absolute after:-left-2.5 after:-translate-y-[2px]': (roundIndex + noOfDisplayedRounds === noOfRounds && [81,143,108].includes(leagueId)),
									     'before:!border-b-0 before:!border-r-0 before:!w-[294px] before:!h-fit before:left-2.5': cupRoundName(roundsToShow[1][0]) === 'Finał' }"
									     :key="match.match_id"
									     v-for="(match, index) in roundsToShow[1][1]['round_matches']">
										<LadderMatch :league_id="leagueId" :variant="cupRoundName(roundsToShow[1][0]) === 'Finał' ? 'final' : ''"
                                 class="bracket-line-start" :match="match"
                                 :column-count="isEuroOnMainPage && window.size.desktop ? 3 : 2"/>
										<LadderMatch class="!absolute top-[150px]" variant="third" v-if="roundsToShow[1][1].third_place"
                                 :match="roundsToShow[1][1].third_place" />
									</div>
								</div>
                <div v-if="roundsToShow[2] && noOfDisplayedRounds > 2" class="flex flex-col"
                     :class="{ '!h-[222px]' : roundsToShow[2][1].third_place }"
                     :style="{ height: `${baseDivHeight * roundsToShow[0][1]['round_matches'].length}px` }">
                  <div class="grid items-center relative h-[332px]"
                       :class="{ 'bracket-lines before:h-full': index % 2 === 0,
									     'before:!border-b-0 before:!border-r-0 before:!w-[294px] before:!h-fit before:left-2.5': cupRoundName(roundsToShow[2][0]) === 'Finał' }"
                       :key="match.match_id"
                       v-for="(match, index) in roundsToShow[2][1]['round_matches']">
                    <LadderMatch :league_id="leagueId" :variant="cupRoundName(roundsToShow[2][0]) === 'Finał' ? 'final' : ''"
                                 class="bracket-line-start" :match="match"
                                 :column-count="isEuroOnMainPage && window.size.desktop ? 3 : 2"/>
                    <LadderMatch class="!absolute top-[150px]" variant="third" v-if="roundsToShow[2][1].third_place"
                                 :match="roundsToShow[2][1].third_place" />
                  </div>
                </div>
							</div>
						</Transition>
					</div>
				</div>
				<div v-else-if="!loading">
					<p class="text-xs text-zt-more text-center border border-zt-light rounded-zt font-normal w-full
					          -leading-[0.18px] bg-zt-light-full py-2.5">
						Brak informacji o drabince
					</p>
				</div>
			</Transition>
		</div>
	</div>
  <div v-else-if="!loading && shouldDisplayLadderInTeam">
    <p v-if="isOverviewPage" class="text-xl font-semibold pl-2.5 mb-2.5 mt-6 xl:pl-0">Drabinka - {{ leagueName }}</p>
    <p class="text-xs text-zt-more text-center border border-zt-light rounded-zt font-normal w-full
					          -leading-[0.18px] bg-zt-light-full py-2.5">
      Brak informacji o drabince
    </p>
  </div>
</template>

<script>
import LadderMatch from '../football_stats/blocks/LadderMatch.vue';
import football_mixin from '../../mixins/football_mixin';
import { ladderPlaceholders } from '../../../assets/js/ladder-placeholders';

export default {
	name: 'Ladder',
	components: {LadderMatch},
	mixins: [football_mixin],
	inject: ['WP'],
  props: {
    showOnlyIfTeamIsPresent: {
      type: Boolean,
      default: false
    }
  },
	data() {
		return {
			loading: true,
			roundIndex: 0,
			oldestRoundMatches: 0,
			baseDivHeight: 83,
			osInstance: null,
			rounds: [],
			roundsEntries: [],
			noOfDisplayedRounds: window.size.mobile ? 1 : 2,
			scrollPos: 0,
		}
	},
  computed: {
    shouldDisplayLadderInTeam() {
      if (!this.WP.team || !this.showOnlyIfTeamIsPresent) {
        return true;
      }

      const team_id = this.WP.team.team_id;
      const matches = this.roundsEntries.flatMap(([roundName, roundData]) => roundData.round_matches);

      return matches.some(match => {
        return match.localteam_id === team_id || match.visitorteam_id === team_id;
      });
    },
    roundsToShow() {
      let start = this.roundIndex;
      return this.roundsEntries.slice(start, start + this.noOfDisplayedRounds);
    },
    noOfRounds() {
      return Object.keys(this.roundsEntries).length;
    },
    leagueType() {
      return this.$attrs.leagueType || 'league';
    },
    leagueId() {
      return +this.$attrs.leagueId;
    },
    leagueName() {
      return this.$attrs.leagueName;
    },
    countryName() {
      return this.$attrs.countryName;
    },
	  isOverviewPage() {
		  if (!this.$attrs.isOverview) {
			  return false;
		  }
		  return this.$attrs.isOverview === 'true';
	  },
    isEuroOnMainPage() {
      return this.$attrs.isEuroOnMainPage === 'true';
    },
    showLadderInNationalTeamPages() {
      let showLadder = false;
      if (this.roundsEntries) {
        let allRounds = Object.values(Object.fromEntries(this.roundsEntries));
        let team_names = [this.WP.team?.team_name ?? null, this.WP.team?.team_short_name ?? null];
        allRounds.forEach(round => {
          if (round.round_matches.some(match => {
            if (match.status === 'PLACEHOLDER') {
              return team_names.includes(match.top_team) || team_names.includes(match.bottom_team);
            } else {
              return this.WP.team?.team_id === match.localteam_id || this.WP.team?.team_id === match.visitorteam_id;
            }
          })) {
            showLadder = true;
          }
        })
      }
      return showLadder;
    }
  },
	async mounted() {
    if (this.isEuroOnMainPage && window.size.desktop) {
      this.noOfDisplayedRounds = 3;
    }
		const response = await axios.post(this.WP.ajaxUrl, {
			endpoint: 'api_get_cup_bracket_data',
			initial_round_matches: this.leagueId === 45 ? 32 : 0,
			league_id: this.leagueId,
			status_array: ['FT', 'PEN', 'AET', '1H', 'HT', '2H', 'ET', 'TBD', 'NS', 'PST'],
		})
		this.rounds = response.data.data;

    let updatedRounds = {};
    for (let key in this.rounds) {
      let newKey = key.replace(/\s*id_\S*/, "");
      updatedRounds[newKey] = this.rounds[key];
    }
    this.rounds = updatedRounds;

    let placeholders = [];
    switch (this.leagueId) {
      case 2:
        placeholders = ladderPlaceholders.LM.rounds;
        break;
      case 3:
        placeholders = ladderPlaceholders.LE.rounds;
        break;
      case 5:
        placeholders = ladderPlaceholders.LN.rounds;
        break;
      case 4:
        placeholders = ladderPlaceholders.Euro.rounds;
        break;
      case 9:
        placeholders = ladderPlaceholders.Copa.rounds;
        break;
      case 22:
        placeholders = ladderPlaceholders.GC.rounds;
        break;
      case 480:
        placeholders = ladderPlaceholders.OL.rounds;
        break;
      case 848:
        placeholders = ladderPlaceholders.LKE.rounds;
        break;
      default:
        placeholders = []
    }
    if (this.rounds && Object.keys(this.rounds).length > 0 && Object.keys(placeholders).length > Object.keys(this.rounds).length) {
      const placeholdersRounds = placeholders;
      const responseData = response.data.data;
      const roundsEntries = Object.entries(placeholdersRounds);

      this.rounds = placeholdersRounds;
      this.roundsEntries = roundsEntries.map(([roundName, roundData]) => {
        const updatedRoundMatches = roundData.round_matches.map(match => {
          const responseRoundData = responseData[roundName];
          if (responseRoundData && responseRoundData.round_matches) {
            const index = responseRoundData.round_matches.findIndex(el => {
              return el.visitorteam_team_query_name === match.visitorteam_team_query_name &&
                  el.localteam_team_query_name === match.localteam_team_query_name;
            });
            if (index !== -1) {
              return responseRoundData.round_matches[index];
            }
          }
          return match;
        });

        return [roundName.replace(/\s*id_\S*/, ""), { ...roundData, round_matches: updatedRoundMatches }];
      });

      this.roundsEntries.forEach(([roundName, roundData], roundIndex) => {
        roundData.round_matches.forEach((match, matchIndex) => {
          if (this.checkStatus(match.status) && (!match.match_2 || this.checkStatus(match.match_2?.status))) {
            const nextRoundIndex = roundIndex + 1;
            const nextMatchIndex = Math.floor(matchIndex / 2);
            const finalResult = this.getFinalMatchResult(match);
            const winningTeam = finalResult > 0 ? {
              team_name: match.localteam_shortname ? match.localteam_shortname : match.localteam_name,
              team_query_name: match.localteam_team_query_name
            } : {
              team_name: match.visitorteam_shortname ? match.visitorteam_shortname : match.visitorteam_name,
              team_query_name: match.visitorteam_team_query_name
            };

            if (this.roundsEntries[nextRoundIndex]) {
              const nextRoundMatches = this.roundsEntries[nextRoundIndex][1].round_matches[nextMatchIndex];
              if (matchIndex % 2 === 0) {
                nextRoundMatches.top_team = winningTeam.team_name;
                nextRoundMatches.localteam_team_query_name = winningTeam.team_query_name;
              } else {
                nextRoundMatches.bottom_team = winningTeam.team_name;
                nextRoundMatches.visitorteam_team_query_name = winningTeam.team_query_name;
              }
            }
          }
        });
      });
      this.oldestRoundMatches = this.roundsEntries[0][1]['round_matches'].length;
      this.createOverlayScrollbar();
    } else if (this.rounds && Object.keys(this.rounds).length > 0) {
			this.roundsEntries = Object.entries(this.rounds);
			this.oldestRoundMatches = this.roundsEntries[0][1]['round_matches'].length;
			this.createOverlayScrollbar();
		} else if (this.rounds && Object.keys(this.rounds).length === 0 && (this.leagueId === 4 || this.leagueId === 9 || this.leagueId === 480)) {
			this.rounds = placeholders;
			this.roundsEntries = Object.entries(this.rounds);
			this.oldestRoundMatches = this.roundsEntries[0][1]['round_matches'].length;
			this.createOverlayScrollbar();
		}

    let index = this.roundsEntries.findIndex(el => el[0] === '3rd Place Final')

    if (index !== -1) {
      this.roundsEntries[this.roundsEntries.length - 1][1].third_place = this.rounds['3rd Place Final'].round_matches[0];
      this.roundsEntries = this.roundsEntries.filter(el => {return el[0] !== '3rd Place Final'});
    }

    if (index === -1 && +this.leagueId === 5) {
      this.roundsEntries[this.roundsEntries.length - 1][1].third_place = placeholders['3rd Place Final'].round_matches[0];
    }

    if (this.noOfRounds >= 2 || window.size.mobile) {
      let roundsWithMatches = 0;
      if (this.WP?.team) {
        roundsWithMatches = Object.keys(this.roundsEntries.slice().filter(el => {
          return el[1].round_matches.some(match => {
            return +match.localteam_id === +this.WP?.team.team_id || +match.visitorteam_id === +this.WP?.team_id;
          })
        })).length;

      } else {
        roundsWithMatches = Object.keys(this.roundsEntries.slice().filter(el => {
          return el[1].round_matches.some(match => {
            return (match.status !== 'NEXT' && match.status !== 'PLACEHOLDER') && (match.localteam_id !== '' || match.visitorteam_id !== '');
          })
        })).length;
      }
      if (roundsWithMatches !== 0) {
        this.roundIndex = window.size.mobile || roundsWithMatches === 1  ? roundsWithMatches - 1 : roundsWithMatches - 2;
      } else {
        this.roundIndex = window.size.mobile || this.noOfRounds === 1 ? this.noOfRounds - 1 : this.noOfRounds - 2;
      }

      const lastRound = this.roundsEntries[this.roundsEntries.length -1];

      if (lastRound && lastRound[0] === 'Final' && lastRound[1].round_matches[0].status === 'NEXT') {
        this.roundIndex = roundsWithMatches - 1;
      }

    }
		this.loading = false;
    this.removePlaceholder(this.$attrs.component);
	},
	methods: {
    getFinalMatchResult(match) {
      let currentResult = this.getResult(match);
      if (!match.match_2) {
        return currentResult;
      }
      if (!['FT', 'PEN', 'AET'].includes(match.match_2.status)) {
        return 0;
      }
      if (match.match_2.localteam_penalty_shootout && match.match_2.visitorteam_penalty_shootout &&
          (match.match_2.localteam_penalty_shootout !== '0' || match.match_2.visitorteam_penalty_shootout !== '0')) {
        return +match.match_2.localteam_penalty_shootout - +match.match_2.visitorteam_penalty_shootout;
      }
        currentResult += +match.match_2.localteam_goals - +match.match_2.visitorteam_goals;
        return currentResult;
    },
    getResult(match) {
      if (this.penaltyShootoutOccurred && !this.secondMatch) {
        return +match.localteam_penalty_shootout - +match.visitorteam_penalty_shootout;
      }
      return +match.localteam_goals - +match.visitorteam_goals;
    },
		createOverlayScrollbar() {
			const interval = setInterval(() => {
				if (this.$refs.bracket) {
					clearInterval(interval);

					this.osInstance = OverlayScrollbars(this.$refs.bracket, {
						scrollbars: {
							theme: 'os-theme-football-bracket',
							dragScroll: true,
							clickScroll: true,
							pointers: ['mouse', 'touch', 'pen'],
						},
					});

					const { viewport } = this.osInstance.elements();
					viewport.scrollTo({ top: this.scrollPos, behavior: 'instant' });

					const { scrollbarVertical } = this.osInstance.elements();
					const { handle } = scrollbarVertical;
					handle.style.right = '1px';
				}
			}, 10);
		},
		previousRound() {
			if (this.roundIndex > 0) {
				const { viewport } = this.osInstance.elements();
				this.scrollPos = viewport.scrollTop;
				this.roundIndex--;
			}
		},
		nextRound() {
			if (this.roundIndex < this.noOfRounds - this.noOfDisplayedRounds) {
				const { viewport } = this.osInstance.elements();
				this.scrollPos = viewport.scrollTop;
				this.roundIndex++;
			}
		}
	},
}
</script>
<style scoped>
.bracket-lines:before {
	@apply overflow-hidden border-r absolute border-zt-light translate-y-1/2 border-y rounded-r-[10px]
         w-[calc(100%+20px)] -left-2.5;
}
.v-enter-active,
.v-leave-active {
	transition: opacity 0.2s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
	transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}
</style>